export default __webpack_public_path__ + "1365b4e3dc01a625864738d46e906fe7.jpeg";